<template>
  <div
    id="champions"
    class="relative flex flex-col justify-center items-center bg-champions-section bg-no-repeat bg-cover py-16 overflow-hidden"
  >
    <section-title titlePath="title-6.png" />
    <div
      class="font-nunito text-center text-grayish-orange w-full max-w-768 mb-12 px-8"
    >
      Champions Scrolls can be unsealed by completing a series of quests. Once
      unsealed, you can start utilizing the 7 Champions for an extra, powerful
      skill that annihilates everything around you. You can rank up each
      Champions by spending your Champion Points.
    </div>
    <div class="w-full box-border carousel-wrapper">
      <VueSlickCarousel v-bind="settings" class="champion-carousel">
        <div
          v-for="(champion, index) in championsData"
          :key="index"
          class="card-wrapper"
        >
          <div class="card-content-wrapper relative flex mx-2 mt-10">
            <div class="dark-layout"></div>
            <img :src="`${imgPath}${champion.image}`" />
            <div
              class="card-content absolute bottom-0 w-full flex flex-col justify-start items-center px-6 pb-6 lg:w-full"
            >
              <span
                class="text-white font-elmessiri text-xl tracking-wide text-shadow-name text-center"
                v-html="champion.name"
              ></span>
              <div class="py-1">
                <img :src="`${imgPath}/slide3/goldline.png`" />
              </div>
              <p
                class="font-nunito text-white text-center max-h-115 overflow-y-auto"
                v-html="champion.desc"
              ></p>
              <span class="masking"></span>
            </div>
          </div>
        </div>
        <template #prevArrow="arrowOption">
          <div
            class="bg-prev-arrow bg-center bg-cover w-24 h-24 cursor-pointer m-auto z-10 absolute top-1/2 left-0 transform translate-x-0 -translate-y-1/2"
          ></div>
        </template>
        <template #nextArrow="arrowOption">
          <div
            class="bg-next-arrow bg-center bg-cover w-24 h-24 cursor-pointer m-auto z-10 absolute top-1/2 right-0 transform translate-x-0 -translate-y-1/2"
          ></div>
        </template>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
//import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  components: { SectionTitle, VueSlickCarousel },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      settings: {
        dots: false,
        arrows: true,
        centerMode: true,
        centerPadding: '60px',
        focusOnSelect: true,
        slideToScroll: 1,
        slideToShow: 1,
        autoplay: false,
        variableWidth: true,
        adaptiveHeight: true,
      },
      championsData: [
        {
          image: '/slide7/zicard.png',
          name: 'Sword Master Ziskad',
          desc: 'Summon a giant sword to slash everything around you',
        },
        {
          image: '/slide7/lo.png',
          name: 'Blizzard Empress lo',
          desc: 'Summon a blizzard storm to freeze everything around you',
        },
        {
          image: '/slide7/adkina.png',
          name: 'Dragon King Atkina',
          desc: 'Summon an elder dragon to decimate everything around you.',
        },
        {
          image: '/slide7/medea.png',
          name: 'Guardian Medea',
          desc: ' Summon a botanical garden to blow up everything around you.',
        },
        {
          image: '/slide7/shynic.png',
          name: 'Dark Lady Shynic',
          desc: ' Summon a dark scythe to slice everything around you.',
        },
        {
          image: '/slide7/vice.png',
          name: 'Dark Lord Vice',
          desc: ' Summon a lightning storm to vaporize everything around you.',
        },
        {
          image: '/slide7/valdrick.png',
          name: 'Lone Warrior Valdrick',
          desc: 'Unknown final champion',
        },
      ],
    };
  },
};
</script>

<style lang="postcss" scoped>
.champion-carousel >>> .slick-list {
  @apply h-504 overflow-x-hidden !important;
}
.champion-carousel >>> .slick-list .slick-track .slick-slide {
  @apply w-316 h-504 relative lg:w-252 lg:h-440;
}
.slick-slide .dark-layout {
  @apply absolute w-full max-w-300 h-full left-0 top-0 bg-black bg-opacity-70;
}
.slick-slide .card-content {
  @apply opacity-0;
}
.slick-active .dark-layout {
  @apply absolute w-full h-full left-0 top-0 !important;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
}
.slick-active .card-content {
  @apply opacity-100;
}
.slick-slide .card-wrapper {
  @apply absolute transition transform translate-y-0 duration-100 ease-in;
}
.slick-active .card-wrapper {
  @apply transition transform -translate-y-10 duration-500 ease-out;
}
.card-dot {
  background: linear-gradient(157.96deg, #feecbc 0%, #c5a576 100%);
  @apply block w-2 h-2 transform rotate-45 m-1;
}
</style>
